import { atom, RecoilState } from "recoil";
import { ESupportedGames } from "MVVM/@types";
import { persistAtom } from "./persist";
import { TFlashBanner } from "MVVM/Views/MatchHistory/@types";

export type TClipsRequested = {
  round: number;
  matchId: string;
  steamId: string;
  ts: number;
};

export type TMontageRequest = {
  type: "MH" | "SH";
  matchId: string;
  steamIds: string[];
  ts: number;
  trackId: string;
};

interface IMatchPreviewStatus {
  success: boolean;
  message: string;
}

type TMatchPreviewStatus = {
  [key: string | number]: IMatchPreviewStatus;
};

export type MatchHistoryWidgetSource = "default" | "iframe";

// export const MatchHistorySession: RecoilState<TMatchHistoryState> = atom({
//   key: "MatchHistorySession_V0.2",
//   default: {
//     totalMatches: 0,
//     totalAvailableClips: 0,
//     steamId: "",
//     matchHistoryData: [] as TMatchHistory[],
//     currentPageHistory: [] as TMatchHistory[],
//     clipsRequested: [] as TClipsRequested[],
//     montagesRequested: [] as TMontageRequest[],
//     page: 1,
//     displayMobileMoments: false as boolean,
//     steamFriends: [] as TSteamFriend[],
//     hasASignature: true as boolean,
//   },
// });

export const MatchPreviewStatus: RecoilState<TMatchPreviewStatus> = atom({
  key: "MatchPreviewStatus_V0.1",
  default: {},
});

export const MatchHistoryGame = atom<ESupportedGames>({
  key: "MatchHistoryGame_V0.1",
  default: (() => {
    const params = new URLSearchParams(window.location.search);
    const gameParam = params.get("game");
    return gameParam
      ? (Number(gameParam) as ESupportedGames)
      : ESupportedGames.NONE;
  })(),
  effects_UNSTABLE: [persistAtom],
});
export const ProcessingMontages = atom({
  key: "ProcessingMontages_V0.1",
  default: [] as string[],
});
export const MatchHistorySelectedMatch = atom({
  key: "MatchHistorySelectedMatch_V0.1",
  default: (() => {
    const params = new URLSearchParams(window.location.search);
    const idParam = params.get("matchId");
    return {
      id: idParam ? idParam : "",
    };
  })(),
});

export const MatchHistoryFlashBanner = atom<TFlashBanner>({
  key: "MatchHistoryFlashBanner_V0.1",
  default: "ready",
});

export const MatchHistoryPanelOpen = atom({
  key: "MatchHistoryPanelOpen_V0.1",
  default: false,
});

export const RequestedMontages = atom({
  key: "RequestedMontages_V0.1",
  default: [] as TMontageRequest[],
});
export const RequestedClips = atom({
  key: "RequestedClips_V0.1",
  default: [] as TClipsRequested[],
});

export const IsOwnMatchHistory = atom({
  key: "IsOwnMatchHistory_V0.1",
  default: true,
});
export const MatchHistoryWidgetOpen = atom({
  key: "MatchHistoryWidgetOpen_v0.1",
  default: true,
  effects_UNSTABLE: [persistAtom],
});

export const MatchHistoryplayerToSearchFor = atom<string | null>({
  key: "MatchHistoryplayerToSearchFor_v0.1",
  default: null,
});

export const MomentsPlayerOverride = atom<string | null>({
  key: "MomentsPlayerOverride_v0.1",
  default: null,
});

export const MatchHistoryWidgetSourceState = atom<MatchHistoryWidgetSource>({
  key: "MatchHistoryWidgetSourceState",
  default: "default",
});

export const MatchHistoryWidgetIndentifierState = atom<string>({
  key: "MatchHistoryWidgetIndentifierState",
  default: "",
});

export const MatchHistoryMatchThumbnailState = atom<string>({
  key: "MatchHistoryMatchThumbnailState",
  default: "",
});

export const RenderMatchHistoryWidgetOnProfile = atom({
  key: "RenderMatchHistoryWidgetOnProfile",
  default: true,
  effects_UNSTABLE: [persistAtom],
});

export const MatchHistorySearchBarIsOpenState = atom<boolean>({
  key: "MatchHistorySearchBarIsOpenState",
  default: false,
});

export type CS2Result = "win" | "loss" | "tie";
export type CS2MinMomentKills = 1 | 2 | 3 | 4 | 5;

export type CS2Filters = {
  map?: string;
  faceitOnly?: boolean;
  wingmanOnly?: boolean;
  result?: CS2Result;
  minKills?: number;
  minMomentKills?: CS2MinMomentKills;
};

export const MatchHistoryPanelExpanded = atom<boolean>({
  key: "MatchHistoryPanelExpanded",
  default: false,
});

export const CS2MatchHistoryFilters = atom<CS2Filters>({
  key: "CS2MatchHistoryFilters_v0.5",
  default: {},
});
